"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiChannel = void 0;
const topic_1 = require("../../topic");
const UI_CHANNEL = "ui";
class UiChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.dialogType = {};
        this.channel = UI_CHANNEL;
        this.topics = {
            DeviceUpdate: new topic_1.Topic('DeviceUpdate', UI_CHANNEL, this._logger),
            DeviceInformation: new topic_1.Topic('DeviceInformation', UI_CHANNEL, this._logger),
            Dialog: new topic_1.Topic('Dialog', UI_CHANNEL, this._logger),
            DialogShow: new topic_1.Topic('DialogShow', UI_CHANNEL, this._logger),
            cookieBannerToggleVisibility: new topic_1.Topic('cookieBannerToggleVisibility', UI_CHANNEL, this._logger),
            CreateAppContainer: new topic_1.Topic('CreateAppContainer', UI_CHANNEL, this._logger),
            RemoveAppContainer: new topic_1.Topic('RemoveAppContainer', UI_CHANNEL, this._logger),
            ShowAppError: new topic_1.Topic('ShowAppError', UI_CHANNEL, this._logger),
            OpenTouchidSettingsPage: new topic_1.Topic('OpenTouchidSettingsPage', UI_CHANNEL, this._logger),
            Toast: new topic_1.Topic('Toast', UI_CHANNEL, this._logger),
            messageActionTaken: new topic_1.Topic('messageActionTaken', UI_CHANNEL, this._logger),
            messageDisplayed: new topic_1.Topic('messageDisplayed', UI_CHANNEL, this._logger),
            openFavouriteSportsModal: new topic_1.Topic('openFavouriteSportsModal', UI_CHANNEL, this._logger),
            webLoginIsShown: new topic_1.Topic('webLoginIsShown', UI_CHANNEL, this._logger),
            webLoginLoaded: new topic_1.Topic('webLoginLoaded', UI_CHANNEL, this._logger),
            resetLoginForm: new topic_1.Topic('resetLoginForm', UI_CHANNEL, this._logger),
            checkWebLoginIsShown: new topic_1.Topic('checkWebLoginIsShown', UI_CHANNEL, this._logger),
            webLoginShow: new topic_1.Topic('webLoginShow', UI_CHANNEL, this._logger),
            controlCenterShow: new topic_1.Topic('controlCenterShow', UI_CHANNEL, this._logger),
            UserAreaReady: new topic_1.Topic('UserAreaReady', UI_CHANNEL, this._logger),
            toggleAppContainer: new topic_1.Topic('toggleAppContainer', UI_CHANNEL, this._logger),
            appContainerReady: new topic_1.Topic('appContainerReady', UI_CHANNEL, this._logger),
            scrollActivation: new topic_1.Topic('scrollActivation', this.channel, this._logger),
            scrollToTop: new topic_1.Topic('scrollToTop', this.channel, this._logger),
            toggleUserArea: new topic_1.Topic('toggleUserArea', UI_CHANNEL, this._logger),
        };
    }
}
exports.UiChannel = UiChannel;
//# sourceMappingURL=ui.channel.js.map